import React from 'react';
import { Login, LoginForm, TextInput, required } from 'react-admin';
import { Box, Button, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getEnv } from '@src/apis/shared';

const OktaSignInButton = () => {
  const navigate = useNavigate();
  const oktaConfigured = !!(getEnv('OKTA_BASE_URI') && getEnv('OKTA_CLIENT_ID'));
  if (!oktaConfigured) return null;

  return (
    <Box sx={{ px: 2, pb: 2 }}>
      <Divider sx={{ my: 1 }}>
        <Typography variant="caption" color="text.secondary">or</Typography>
      </Divider>
      <Button fullWidth variant="outlined" onClick={() => navigate('/sso')}>
        Sign in with SSO
      </Button>
    </Box>
  );
};

const CustomLogin = () => (
  <Login>
    <LoginForm>
      <TextInput
        autoFocus
        source="badge"
        label="Badge"
        autoComplete="badge"
        type="badge"
        validate={required()}
      />
    </LoginForm>
    <OktaSignInButton />
  </Login>
);

export default CustomLogin;
